// Polyfill for IE11 support
import 'es6-object-assign/auto'

exports.onClientEntry = () => {
  // Don't need to do anything here, but if you don't 
  // export something, the import won't work.
}




// WEBPACK FOOTER //
// ./gatsby-browser.js